import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 60px;
	left: 50%;
	transform: translateX(-50%);
	width: 340px;
`;

const StyledWrapper = styled.div<{ $hide?: boolean }>`
	position: absolute;
	transition:
		opacity 1s ease,
		transform 1s ease;
	opacity: ${({ $hide }) => ($hide ? 0 : 1)};
	transform: translateX(${({ $hide }) => ($hide ? '100%' : 0)});
`;

const StyledCircle = styled.circle`
	transition:
		opacity 1s ease,
		cx 1s ease,
		cy 1s ease,
		r 1s ease,
		fill 1s ease;
`;

const StyledText = styled.div`
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;
	text-shadow:
		1px 0 0 rgba(0, 0, 0, 0.4),
		0 1px 0 rgba(0, 0, 0, 0.4),
		-1px 0 0 rgba(0, 0, 0, 0.4),
		0 -1px 0 rgba(0, 0, 0, 0.4);
	user-select: none;
	text-align: center;
	width: max-content;
`;

const StyledFirstTextContainer = styled.div<{ $hide?: boolean }>`
	position: absolute;
	top: 20px;
	left: 50%;
	transition:
		opacity 1s ease,
		transform 1s ease;
	opacity: ${({ $hide }) => ($hide ? 0 : 1)};
	transform: translateX(${({ $hide }) => ($hide ? '100%' : '-50%')});
`;

const StyledFinishTextContainer = styled.div<{ $show?: boolean }>`
	position: absolute;
	top: 50px;
	left: 50%;
	transition:
		opacity 1s ease,
		transform 1s ease;
	opacity: ${({ $show }) => ($show ? 1 : 0)};
	transform: translateX(${({ $show }) => ($show ? '-50%' : '-100%')});
`;

const StyledImage = styled.image.attrs({ width: 10, height: 10 })`
	filter: invert(100%);
	transition: x 1s ease;
	pointer-events: none;
	transition-delay: 1s;
`;

const StyledDot = styled.circle<{ $isActive?: boolean }>`
	width: 10px;
	height: 10px;
	border-radius: 10px;
	background-color: ${({ $isActive }) =>
		$isActive ? '#FFB500' : 'rgba(255,255,255,0.1)'};
	transition: background-color 1s ease;
`;

const StyledGrid = styled.div`
	position: absolute;
	top: 3px;
	left: 20px;
	display: grid;
	align-items: center;
	gap: 10px;
	width: 300px;
`;

const StyledLineWrapper = styled.div`
	position: relative;
	height: 4px;
	border-radius: 4px;
	background-color: rgba(255, 255, 255, 0.1);
	overflow: hidden;
`;

const StyledLine = styled.line`
	position: absolute;
	top: 0;
	left: 0;
	height: 4px;
	background-color: #ffb500;
	transition: width 1s ease;
`;

export {
	StyledContainer,
	StyledWrapper,
	StyledText,
	StyledFirstTextContainer,
	StyledFinishTextContainer,
	StyledImage,
	StyledDot,
	StyledGrid,
	StyledLineWrapper,
	StyledLine,
	StyledCircle,
};
